import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";
import { ArrowRight, CheckCircle2 } from "lucide-react";

const image =
  "https://images.pexels.com/photos/33342708/pexels-photo-33342708.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200";

export default function Cabinet() {
  const { t } = useLang();
  const values = [t("cabinet.value1"), t("cabinet.value2"), t("cabinet.value3"), t("cabinet.value4")];
  const steps = ["step1", "step2", "step3", "step4"];

  return (
    <div>
      <section className="border-b border-border-light" data-testid="cabinet-intro">
        <div className="container-notary py-20 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <div className="overline mb-4">{t("cabinet.eyebrow")}</div>
            <h1 className="text-4xl md:text-5xl font-serif text-charcoal">{t("cabinet.title")}</h1>
            <span className="divider-gold my-6 block" />
            <p className="text-lg text-charcoal-muted max-w-2xl leading-relaxed">{t("cabinet.intro")}</p>
          </div>
          <div className="lg:col-span-5">
            <div className="border border-border-light overflow-hidden h-[320px] lg:h-[380px]">
              <img src={image} alt="Cabinet" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </section>

      <section className="container-notary py-20 grid grid-cols-1 md:grid-cols-2 gap-10" data-testid="mission-values">
        <div className="card-notary">
          <div className="overline mb-3">{t("cabinet.missionTitle")}</div>
          <h2 className="text-2xl font-serif text-charcoal">{t("cabinet.missionTitle")}</h2>
          <span className="divider-gold my-5 block" />
          <p className="text-charcoal-muted leading-relaxed">{t("cabinet.missionText")}</p>
        </div>
        <div className="card-notary">
          <div className="overline mb-3">{t("cabinet.valuesTitle")}</div>
          <h2 className="text-2xl font-serif text-charcoal">{t("cabinet.valuesTitle")}</h2>
          <span className="divider-gold my-5 block" />
          <ul className="space-y-3">
            {values.map((v) => (
              <li key={v} className="flex items-center gap-3 text-charcoal">
                <CheckCircle2 className="w-4 h-4 text-gold" />
                <span className="font-serif">{v}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="bg-surface-muted border-y border-border-light py-20" data-testid="engagement-section">
        <div className="container-notary grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="overline mb-3">{t("cabinet.engagementTitle")}</div>
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal">{t("cabinet.engagementTitle")}</h2>
            <span className="divider-gold my-5 block" />
            <p className="text-charcoal-muted leading-relaxed">{t("cabinet.engagementText")}</p>
          </div>
          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-border-light border border-border-light">
              {steps.map((s, idx) => (
                <div key={s} className="bg-surface p-8 flex flex-col gap-3">
                  <div className="overline">{String(idx + 1).padStart(2, "0")}</div>
                  <h3 className="font-serif text-lg text-charcoal">{t(`cabinet.${s}.title`)}</h3>
                  <p className="text-sm text-charcoal-muted">{t(`cabinet.${s}.desc`)}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="container-notary py-20" data-testid="cabinet-cta">
        <div className="border border-border-light p-10 md:p-14 grid grid-cols-1 lg:grid-cols-3 gap-6">
          <Link to="/services" className="group flex flex-col gap-3 p-6 border border-border-light hover:border-gold transition-colors">
            <div className="overline">{t("nav.services")}</div>
            <span className="font-serif text-xl text-charcoal">{t("nav.services")}</span>
            <ArrowRight className="w-4 h-4 text-gold rtl-flip group-hover:translate-x-1 transition" />
          </Link>
          <Link to="/documents" className="group flex flex-col gap-3 p-6 border border-border-light hover:border-gold transition-colors">
            <div className="overline">{t("nav.documents")}</div>
            <span className="font-serif text-xl text-charcoal">{t("nav.documents")}</span>
            <ArrowRight className="w-4 h-4 text-gold rtl-flip group-hover:translate-x-1 transition" />
          </Link>
          <Link to="/rendez-vous" className="group flex flex-col gap-3 p-6 border border-border-light hover:border-gold transition-colors">
            <div className="overline">{t("common.bookAppointment")}</div>
            <span className="font-serif text-xl text-charcoal">{t("common.bookAppointment")}</span>
            <ArrowRight className="w-4 h-4 text-gold rtl-flip group-hover:translate-x-1 transition" />
          </Link>
        </div>
      </section>
    </div>
  );
}
